export abstract class Transform {
    public abstract handles(object: any): boolean;
    public abstract transform(object: any): any;
}
